"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterTypoStyles = void 0;
var filterFontStyles = function (styles) {
    return Object.entries(styles).reduce(function (stylesAcc, _a) {
        var key = _a[0], prop = _a[1];
        if (key === 'fontFamily' ||
            key === 'fontSize' ||
            key === 'fontStyle' ||
            key === 'fontWeight' ||
            key === 'letterSpacing' ||
            key === 'lineHeight') {
            stylesAcc[key] = prop;
        }
        return stylesAcc;
    }, {});
};
/**
 * Из объекта со стилями типографических констант создаст объект
 * переменных, пригодный для транформации в объект темы.
 */
var filterTypoStyles = function (typoStyles) {
    return Object.entries(typoStyles).reduce(function (textAcc, _a) {
        var text = _a[0], styles = _a[1];
        textAcc[text] = filterFontStyles(styles);
        return textAcc;
    }, {});
};
exports.filterTypoStyles = filterTypoStyles;
//# sourceMappingURL=filterTypoStyles.js.map